import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormInput } from '@/shared/components/ui/form/components/form-input/form-input';
import { Submit } from '@/shared/components/ui/form/components/submit/submit';
import {
  FormContainer,
  FormContent,
} from '@/shared/components/ui/form/form.styled';
import { GroupSelect } from '@/shared/features/groups/components/group-select/group-select';
import { TUpdateUserInputSchema } from '@/shared/features/rbac/components/update-user/update-user.types';
import { TUpdateUserFormProps } from '@/shared/features/rbac/components/update-user-form/update-user-form.types';
import { UserSourceEnum } from '@/shared/types/types.generated';

export const UpdateUserForm: React.FC<TUpdateUserFormProps> = ({
  handleClose,
  userSource,
  canEditGroup = true,
}) => {
  const { t } = useTranslation();

  return (
    <FormContainer justifyContent="space-between">
      <FormContent overflow="auto">
        <Stack direction="row" gap="0.75rem">
          <FormInput<TUpdateUserInputSchema>
            name="firstName"
            label={t('rbac:first_name')}
            required
            disabled={userSource !== UserSourceEnum.Sda}
          />
          <FormInput<TUpdateUserInputSchema>
            name="lastName"
            label={t('rbac:last_name')}
            required
            disabled={userSource !== UserSourceEnum.Sda}
          />
        </Stack>
        <FormInput<TUpdateUserInputSchema>
          name="email"
          label={t('rbac:email')}
          required
          disabled
        />
        <FormInput<TUpdateUserInputSchema>
          name="companyName"
          label={t('rbac:company')}
          required
        />
        <GroupSelect<TUpdateUserInputSchema>
          name="groupId"
          getItemId={(value) => value}
          label={t('groups:group')}
          disabled={!canEditGroup}
        />
      </FormContent>
      <Submit
        onClose={handleClose}
        formHasToBeDirty
        submitButtonLabel={t('common:save_changes')}
      />
    </FormContainer>
  );
};
